import { Table, Text } from "@mantine/core";
import { SystemEmailRegistryEntry } from "../../../services/admin/systemEmails.service";

export function SystemEmailRegistryPrimaryCell({
  entry,
}: {
  entry: SystemEmailRegistryEntry;
}) {
  return (
    <Table.Td>
      <Text fw={600}>{entry.subject}</Text>
      <Text c="dimmed" size="sm">
        <Text component="span" fw={600}>
          {entry.label}:
        </Text>{" "}
        {entry.description}
      </Text>
    </Table.Td>
  );
}
